<template>
  <v-container>
    <h1>Financial Product Data</h1>
    <br>

    <v-card>
      <v-card-title :class="getColor()">
        <span class="headline white--text">{{ type | capitalize }} Details</span>
        <v-spacer />
        <v-btn
          v-if="type === 'product'"
          @click="backToProductList"
        >
          back to list
        </v-btn>
        <v-btn
          v-if="type === 'tranche'"
          @click="backToProduct"
        >
          back to product
        </v-btn>
      </v-card-title>

      <v-card-text
        class="px-0 py-0"
      >
        <financial-product-detail-component
          v-if="isLoadFP"
          :financial-product-raw="financialProduct"
          :financial-product="financialProductCalculated"
          :tranches="tranches"
          :type="type"
          @refreshDetailComponent="refreshFinancialProduct"
        />

        <v-layout
          v-else
          justify-center
        >
          <div class="my-3">
            <v-progress-circular
              :size="50"
              :color="getColor()"
              indeterminate
            />
          </div>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { FinancialProductDetailComponent } from '@/components/financialProducts';
import StagesEnum from '@/enum/financialProducts/Stages';

export default {
  name: 'FinancialProductDetails',
  components: {
    'financial-product-detail-component': FinancialProductDetailComponent,
  },
  data() {
    return {
      financialProduct: {},
      financialProductCalculated: {},
      isLoadFP: false,
      type: null,
      tranches: null,
      error: null,
    };
  },
  mounted() {
    this.refreshFinancialProduct();
  },
  methods: {
    ...mapActions([
      'getFinancialProduct',
    ]),
    async refreshFinancialProduct() {
      this.resetData();
      try {
        if (this.$route.name === 'tranche_detail') {
          this.type = 'tranche';
          await this.getFinancialProduct(toQueryString({
            instrument: this.$route.params.instrument,
            security_id_type: this.$route.params.securityIdType,
            security_id: this.$route.params.securityId,
            created_at: this.$route.params.createdAt,
          })).then((response) => {
            this.financialProduct = response.tranche;
            this.financialProductCalculated = response.output.tranche;
          });
        } else {
          this.type = 'product';
          const response = await this.getFinancialProduct(toQueryString({
            instrument: this.$route.params.instrument,
            security_id_type: this.$route.params.securityIdType,
            security_id: this.$route.params.securityId,
          }));
          this.tranches = response.output.tranches;
          this.financialProduct = response.product;
          this.financialProductCalculated = response.output.product;
        }
        this.isLoadFP = true;
      } catch (error) {
        this.account = {};
        this.error = 'No FinancialProduct data found.';
        this.isLoadFP = true;
      }
    },
    resetData() {
      this.isLoadFP = false;
      this.financialProduct = {};
      this.financialProductCalculated = {};
      this.tranches = null;
      this.error = null;
      this.type = null;
    },
    async backToProductList() {
      await this.$router.push(
        '/financial-products/products',
      );
    },
    async backToProduct() {
      await this.$router.push(
        // eslint-disable-next-line max-len
        `/financial-products/product/${this.financialProduct.instrument}/${this.financialProduct.security_id_type}/${this.financialProduct.security_id}`,
      );
      this.refreshFinancialProduct();
    },
    getColor() {
      if (this.financialProduct.stage === StagesEnum.DECLINED) {
        return 'red';
      }
      if (this.type === 'tranche') {
        return 'deep-orange darken-4';
      }

      return 'blue-grey darken-1';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/financialProducts/FinancialProductDetails.vue